import type { IMasterDataProductUomRepository } from "@src/domain/repositories/masterData";
import type { GetMasterDataProductUomsDTO } from "@src/domain/dto/masterData";

export class GetMasterDataProductUomsUseCase {
  private readonly repository: IMasterDataProductUomRepository;

  constructor(repository: IMasterDataProductUomRepository) {
    this.repository = repository;
  }

  execute(params: GetMasterDataProductUomsDTO) {
    return this.repository.getProductUoms(params);
  }
}
